import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractProductDocument.RevisionSave.IRequest;
type Response = Api.Core.ContractProductDocument.RevisionSave.IResponse;
type Headers = Api.Core.ContractProductDocument.RevisionSave.IHeaders;
const url = '/api/Sales/Revision/:id/ProductDocuments';
export default async function revisionProductDocumentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.contractId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
